'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const d3=require('d3');
const _=require('pulsar-utils/dist-es6/_');
const moment=require('pulsar-utils/dist-es6/time/moment');
const NotificationType=require('pulsar-dashboard-core/dist-es6/domain/notificationType');
const ThresholdStatus=require('pulsar-dashboard-core/dist-es6/domain/thresholdStatus');
const StatisticsPanelHelpers=require('../../../../../dist-es6/client/directives/statisticsPanels/statisticsPanelHelpers');
const BaseControllerBackedDirective=require('../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

TotalIncidentsDirective=function(_BaseControllerBacked){_inherits(TotalIncidentsDirective,_BaseControllerBacked);function TotalIncidentsDirective(){_classCallCheck(this,TotalIncidentsDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(TotalIncidentsDirective,[{key:'templateUrl',get:function()
{return'/templates/directives/statisticsPanels/totalIncidents/totalIncidentsTemplate'}},{key:'controller',get:function()
{return TotalIncidentsDirectiveController}},{key:'objectBindings',get:function()
{return[
'incidents',
'fatigueThreshold',
'deviationThreshold',
'notificationType',
'dimensions',
'interval',
'homeTimezone',
'preventAnimations',
'showNotificationType'];
}}]);return TotalIncidentsDirective}(BaseControllerBackedDirective);


const MonthNames=[
'January',
'February',
'March',
'April',
'May',
'June',
'July',
'August',
'September',
'October',
'November',
'December'];


const _getMonthNameFrom=function(time){return MonthNames[time.getMonth()]};let

TotalIncidentsDirectiveController=function(){
function TotalIncidentsDirectiveController($scope,$timeout,dateService,timeZoneService){var _this2=this;_classCallCheck(this,TotalIncidentsDirectiveController);
this._$scope=$scope;
this._$timeout=$timeout;
this._dateService=dateService;
this._timeZoneService=timeZoneService;

if(!_.exists(this.showNotificationType)){
this.showNotificationType=!1;
}

const _redrawIfNew=function(newType,oldType){
if(!_.exists(newType)||newType===oldType){
return;
}

$timeout(function(){return _this2._setupGraphViewData()});
};

$scope.$watch('controller.notificationType',_redrawIfNew);
$scope.$watch('controller.incidents',_redrawIfNew);

this._setupGraphViewData();
}TotalIncidentsDirectiveController.prototype.

_getThresholdStatusFor=function _getThresholdStatusFor(incident){
return ThresholdStatus.determineFrom(
incident.fatigue,
_.get(incident.statistics,'recentHistory.fatigue'),
this.fatigueThreshold,
this.deviationThreshold,
this.notificationType);
};TotalIncidentsDirectiveController.prototype.

_setupGraphViewData=function _setupGraphViewData(){
const aggregateData={
Above:0,
At:0,
Below:0,
NotApplicable:0};

const monthViewData={};
const numPoints=this.incidents.length;
for(let i=0;i<numPoints;i++){
const utcMonthStart=StatisticsPanelHelpers.getUtcReferenceStartOfMonthFor(this.incidents[i].time,this.homeTimezone);

const monthName=_getMonthNameFrom(utcMonthStart);
const thresholdStatus=this._getThresholdStatusFor(this.incidents[i]);

if(!_.exists(monthViewData[monthName])){
monthViewData[monthName]={
Total:0,
Above:0,
At:0,
Below:0,
NotApplicable:0,
monthStart:utcMonthStart};

}

aggregateData[thresholdStatus.value]++;
monthViewData[monthName][thresholdStatus.value]++;
monthViewData[monthName].Total++;
}

this.graphViewData=monthViewData;
this.statusCountsForDonut=aggregateData;
this.totalIncidents=numPoints;
this.graphYAxisDomain=[0,Math.max(3,_(monthViewData).values().map(function(c){return c.Total}).max())];
this.graphXAxisDomain=StatisticsPanelHelpers.getUtcReferenceAxisDomainFor(this.interval,this.homeTimezone);
this.subtitle=this.showNotificationType?`Alerts: ${this.notificationType.description}`:'';
};return TotalIncidentsDirectiveController}();


module.exports=TotalIncidentsDirective;
//# sourceMappingURL=totalIncidentsDirective.js.map
